const _ = require("lodash");
const shopData = require("../../../shared/data/dbShop.json");
const PageShared = require("../../../shared/PageShared");
const Constants = require("../../../shared/Constants");

const getAllApparelSkus = PageShared.getAllApparelSkus;

const getApparelRegex = PageShared.getApparelRegex;

const getApparelInfoFromSku = PageShared.getApparelInfoFromSku;

const getAvailableApparelSkusByPrefix = function(apparelPrefix) {
	return _.keys(
		_.pickBy(
			shopData,
			(i, sku) =>
				i.type === "apparel" && i.inStock && _.startsWith(sku, apparelPrefix)
		)
	);
};

const getAllApparelSizeDescriptions = function() {
	const sizes = {};
	_.each(Constants.APPAREL_CLASSES, c => {
		_.each(Constants.APPAREL_SIZES, s => {
			let description = `${_.capitalize(c)} ${_.capitalize(s)}`;
			description = _.replace(description, "Womens", "Women's");
			// Changed below line to "Adult" even though I think this is irrelevant
			// since I think this was only used before we switched to eleventy
			description = _.replace(description, "Mens", "Adult");
			description = _.replace(description, "X-large", "X-Large");
			sizes[`${c}-${s}`] = description;
		});
	});
	return sizes;
};

const getApparelImageSrc = function(apparelHash, isFront, size) {
	const front = isFront ? "front" : "back";
	const name = [apparelHash, front, size].join("-");
	return global.BASE_URL + "assets/images/apparel/" + name + ".png";
};

module.exports = {
	getAllApparelSkus,
	getApparelRegex,
	getApparelInfoFromSku,
	getAvailableApparelSkusByPrefix,
	getAllApparelSizeDescriptions,
	getApparelImageSrc,
};
